import { render } from "./EventTicketOptions.vue?vue&type=template&id=b3c5b3c6&scoped=true&ts=true"
import script from "./EventTicketOptions.vue?vue&type=script&lang=ts"
export * from "./EventTicketOptions.vue?vue&type=script&lang=ts"

import "./EventTicketOptions.vue?vue&type=style&index=0&id=b3c5b3c6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b3c5b3c6"]])

export default __exports__